import { render, staticRenderFns } from "./DashboardControl.vue?vue&type=template&id=3e0a0b36&scoped=true"
import script from "./DashboardControl.vue?vue&type=script&lang=js"
export * from "./DashboardControl.vue?vue&type=script&lang=js"
import style0 from "./DashboardControl.vue?vue&type=style&index=0&id=3e0a0b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0a0b36",
  null
  
)

export default component.exports